"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prepareEECproductClick = function (_a) {
    var brand = _a.brand, categoryName = _a.categoryName, list = _a.list, name = _a.name, pid = _a.pid, position = _a.position, priceValue = _a.priceValue, trackingToken = _a.trackingToken;
    return ({
        event: 'EECproductClick',
        ecommerce: {
            click: {
                actionField: {
                    list: list,
                    action: 'click',
                },
                products: [
                    {
                        brand: brand,
                        category: categoryName,
                        id: pid,
                        name: name,
                        position: position,
                        price: priceValue,
                        trackingToken: trackingToken,
                    },
                ],
            },
        },
    });
};
exports.default = prepareEECproductClick;
//# sourceMappingURL=prepareEECproductClick.js.map